import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 0, 0, 1)
  },
  emptyText: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  }
}));

export const ProjectCostOverridesReadOnlyContent = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesNoOverridesSet"
      >
        <FormattedMessage id="projectCostOverrides.noCostRateOverridesSet" />
      </Typography>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesCostsBasedOnUser"
      >
        <FormattedMessage id="projectCostOverrides.projectCostsBasedOnUser" />
      </Typography>
    </div>
  );
};

export default ProjectCostOverridesReadOnlyContent;
